













// Copyright © 2021 Move Closer

import { defineComponent } from '@vue/composition-api'

import { tableFakeRowProps, TableFakeRowProps } from '../../../../../../abstract/components/Table'

import { DashmixTableCell } from './TableCell'
import { DashmixTableRow } from './TableRow.vue'

export const DashmixFakeRow = defineComponent({
  name: 'DashmixFakeRow',
  components: { DashmixTableCell, DashmixTableRow },
  props: tableFakeRowProps,

  setup (props: TableFakeRowProps) {
    return {
      getRow: () => {
        return { selectable: props.showSelection, selected: false }
      }
    }
  }
})

export default DashmixFakeRow
